<template>
    <div id="basicSubmissionHistoryModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="basicSubmissionHistoryTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="basicSubmissionHistoryTitle">Submission History</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body">
                    <table class="table table-sm mb-2">
                        <thead>
                            <tr> 
                                <th class="fit">Status</th>
                                <th>Submitted By</th>
                                <th>Recipient</th>
                                <th>Submitted At</th>                              
                                <th class="fit"></th>
                            </tr>
                        </thead>
                        <tbody class="table-font-size">
                            <tr v-for="submission in submissions" :key="'basic-submission-' + submission.transmission_method_id + '-' + submission.outbound_id">
                                <td class="fit">
                                    <div class="pr-1" :title="submission.status_description">
                                        <i :class="statusIcon(submission.transmission_method_id, submission.status_code)"></i>
                                    </div>                                    
                                </td>
                                <td>{{ submission.last_name }}</td>
                                <td v-if="submission.transmission_method_id == TransmissionMethod.FAX">{{ submission.name }} - {{ submission.destination | telephone }}</td>
                                <td v-else>{{ submission.name }} - {{ submission.destination }}</td>
                                <td v-if="submission.transmission_method_id == TransmissionMethod.MAILED">{{ submission.submitted_at }}</td>
                                <td v-else>{{ submission.submitted_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                                <td class="fit">
                                    <div class="d-flex flex-nowrap flex-row justify-content-end">

                                        <div class="text-center pr-2">
                                            <a v-if="submission.confirmation_url" :href="submission.confirmation_url" target="_blank" class="btn btn-link btn-sm py-0 px-1" title="View Confirmation">
                                                <i class="fas fa-clipboard-check fa-lg"></i>
                                            </a>
                                            <i v-else class="fas fa-clipboard-check fa-lg text-muted"></i>                                       
                                        </div>

                                        <div class="text-center">
                                            <a v-if="submission.archive_url" :href="submission.archive_url" target="_blank" class="btn btn-link btn-sm py-0 px-1" title="Download Submission Archive">
                                                <i class="fas fa-file-archive fa-lg"></i>
                                            </a>
                                            <i v-else class="fas fa-file-archive fa-lg text-muted"></i>                                           
                                        </div>

                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>                    
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" data-dismiss="modal">Close</button>                    
                </div>                
            </div>
        </div>
    </div>    
</template>

<script>
import { TransmissionMethod, FaxStatus, EmailStatus, MailedStatus } from '../../constants.js';

export default {
    data() {
        return {
            document: null,
            submissions: [],

            TransmissionMethod,
            FaxStatus,
            EmailStatus,
            MailedStatus
        }
    },
    methods: {
        show: function (document) {

            this.document = document;
            this.submissions = [];

            let url = `/ajax/clients/${document.client_id}/claims/${document.claim_id}/documents/${document.document_id}/basic-submissions`;            
            axios.get(url)
                .then(response => {
                    this.submissions = response.data.submissions;
                    $('#basicSubmissionHistoryModal').modal('show'); 
                })
                .catch(error => {
                    console.log(error.response);
                });
        },
        statusIcon: function (method, code) {

            let retval = 'fas fa-question-circle fa-sm text-secondary status-icon';            

            if (method === TransmissionMethod.FAX) {
                if (code < FaxStatus.DOCUMENT_SENT) { retval = 'fas fa-spinner fa-spin fa-sm text-secondary status-icon'; }
                else if (code === FaxStatus.DOCUMENT_SENT) { retval = 'fas fa-check-circle fa-sm text-success status-icon';}
                else if (code > FaxStatus.DOCUMENT_SENT) { retval = 'fas fa-exclamation-circle fa-sm text-danger status-icon'; }
            }
            else if (method === TransmissionMethod.EMAIL) {
                if (code === EmailStatus.PREPROCESSING) { retval = 'fas fa-spinner fa-spin fa-sm text-secondary status-icon'; }
                else if (code === EmailStatus.SENT) { retval = 'fas fa-clock fa-sm text-primary status-icon'; }
                else if (code === EmailStatus.EXPIRED) { retval = 'fas fa-clock fa-sm text-danger status-icon'; }
                else if (code === EmailStatus.DOWNLOADED) { retval = 'far fa-check-circle fa-sm text-success status-icon'; }
                else if (code === EmailStatus.CONFIRMED) { retval = 'fas fa-check-circle fa-sm text-success status-icon'; }
                else if (code === EmailStatus.ERROR) { retval = 'fas fa-exclamation-circle fa-sm text-danger status-icon'; }
            }
            else if (method === TransmissionMethod.MAILED) {
                if (code === MailedStatus.MAILED) { retval = 'far fa-check-circle fa-sm text-success status-icon'; }
                else if (code === MailedStatus.RECEIVED) { retval = 'fas fa-check-circle fa-sm text-success status-icon'; }
            }            

            return retval;
        }
    },
    created() {
        eventHub.$on('show-basic-submission-history', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-basic-submission-history');
    }    
}
</script>

<style scoped>

</style>